import styled from 'styled-components'

export const Viewer = styled.main.attrs({})`
  display: flex;
  width: 100%;
  max-width: 1180px;
  flex-direction: column;
  gap: 28px;
`

export const DescriptionPanel = styled.section.attrs({})`
  display: flex;
  width: 100%;
  padding: clamp(24px, 4vw, 36px);
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 20px;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  box-shadow: 0 18px 44px ${p => p.theme.palette.colors.shadowStrong};
  flex-direction: column;
  gap: 12px;
`

export const DescriptionTitle = styled.h2.attrs({})`
  margin: 0;
  font-family: Gilroy;
  font-size: clamp(24px, 3vw, 30px);
  font-weight: 700;
  line-height: 1.2;
  color: ${p => p.theme.palette.colors.text};
`

export const Description = styled.p.attrs({})`
  max-width: 860px;
  margin: 0;
  white-space: pre-wrap;
  font-family: Poppins;
  font-size: 16px;
  line-height: 1.7;
  color: ${p => p.theme.palette.colors.muted};
`
